import { useTranslation } from "react-i18next";
import { useAgreementData } from "../../hooks";
import { AgreementAttachmentsDisplay } from "../shared";
import { AGREEMENT_DOCUMENTS_ATTACHMENT_TYPE } from "@/constants";
import { CollapsibleSection } from "@/components/CollapsibleSection";

export const AgreementDocumentsSection = () => {
  const { t } = useTranslation();
  const { agreement_files } = useAgreementData();

  if (!agreement_files || agreement_files.length === 0) {
    return null;
  }

  const attachmentGroups = [
    {
      key: "agreement_files",
      files: agreement_files,
      title: t("agreements.attachments.agreement_files"),
    },
  ];

  return (
    <CollapsibleSection title={t("agreements.documents.title")}>
      <AgreementAttachmentsDisplay
        attachments={attachmentGroups}
        attachmentType={AGREEMENT_DOCUMENTS_ATTACHMENT_TYPE}
      />
    </CollapsibleSection>
  );
};
